<template>
  <div>
    <generic-view
      :title="$t('calendar')"
      icon="calendar alternate"
      v-bind:searchable="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-bind:show_plus="true"
      v-on:add="create"
    >
      <FullCalendar
        ref="fullCalendar"
        defaultView="timeGridWeek"
        :plugins="calendarPlugins"
        :header="header"
        :events="events"
        :aspectRatio="1.6"
        :businessHours="businessHours"
        v-bind:locale="$i18n.locale"
        editable="true"
        @dateClick="dateClick"
        @eventClick="eventClick"
        @eventDrop="eventDrop"
        @eventResize="eventResize"
        v-if="show_calendar"
      />
      <event-modal
        ref="event_modal"
        @succedded="succedded"
        @deleted="succedded"
      />
      <!-- <template v-for="(mdl, index) in event_modals">
        <component
          :is="mdl"
          :key="index"
          v-on:succedded="succedded"
          :event="event"
        ></component>
      </template> -->
    </generic-view>
  </div>
</template>

<script>
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/locales-all";

import GenericView from "@/components/GenericContainer";
import EventModal from "@/modules/calendar/event_modal/Index";

import ConfigureModal from "./configuration_modal/Index.vue";

import { local_api, error_toast } from "@/utils";

export default {
  components: {
    FullCalendar: FullCalendar,
    "generic-view": GenericView,
    EventModal,
  },
  data() {
    return {
      processing: false,
      show_calendar: false,
      calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      header: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay",
      },
      businessHours: {
        startTime: "", // "08:00",
        endTime: "", // "18:00",
        daysOfWeek: [], // [0, 1, 2, 3, 4, 5, 6],
      },
      event: {},
      configure_modal: ConfigureModal,
      // event_modals: []
    };
  },
  methods: {
    events(fetchInfo, successCallback, failureCallback) {
      this.processing = true;
      local_api(this, "post", "/calendar/do-get-events", fetchInfo)
        .then((response) => {
          let events = response.map((evt) => {
            return {
              id: evt.event_id,
              title: evt.setup.title,
              description: evt.setup.description,
              start: evt.start_at,
              end: evt.end_at,
              editable: true,
              startEditable: true,
              durationEditable: true,
              overlap: true,
              modul_object: evt,
              color: evt.setup.color,
            };
          });
          successCallback(events);
        })
        .catch((err) => {
          failureCallback(err);
        })
        .finally(() => {
          this.processing = false;
        });
    },
    dateClick(info) {
      // this.event = {
      //   start_at: info.date
      // };
      // this.event_modals.push(EventModal);
      this.$refs.event_modal.show_modal({
        type: "date_click",
        info: info,
      });
    },
    eventClick(info) {
      // this.event = info.event.extendedProps.modul_object;
      // this.event_modals.push(EventModal);
      this.$refs.event_modal.show_modal({
        type: "event_click",
        info: info.event.extendedProps.modul_object,
      });
    },
    eventDrop(info) {
      let vm = this;
      let setup = info.event.extendedProps.modul_object.setup;
      setup.event_id = info.event.id;
      setup.start_date = info.event.start;
      setup.end_date = info.event.end;
      local_api(vm, "post", "/calendar/do-save-event", setup)
        .then(() => {})
        .catch((err) => {
          error_toast(err);
        });
    },
    eventResize(info) {
      let vm = this;
      let setup = info.event.extendedProps.modul_object.setup;
      setup.event_id = info.event.id;
      setup.start_date = info.event.start;
      setup.end_date = info.event.end;
      local_api(vm, "post", "/calendar/do-save-event", setup)
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    configure() {},
    create() {
      this.event = {};
      // this.event_modals.push(EventModal);
      this.$refs.event_modal.show_modal();
    },
    succedded() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.refetchEvents();
    },
    get_configuration() {
      let vm = this;
      local_api(vm, "post", "/calendar/configuration/do-get")
        .then((conf) => {
          vm.show_calendar = true;
          // console.log("conf", conf);

          if (conf && conf.start_time)
            vm.businessHours.startTime = conf.start_time;
          if (conf && conf.end_time) vm.businessHours.endTime = conf.end_time;
          if (conf && conf.working_days) {
            let wrkngDays = conf.working_days.split(",");
            vm.businessHours.daysOfWeek = wrkngDays;
          }

          // setTimeout(() => {
          //   let calendarApi = vm.$refs.fullCalendar.getApi();
          //   console.log("calendarApi: " + calendarApi);
          //   calendarApi.view.render();
          // });
        }, 500)
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    window.jQuery(this.$refs.search).search({
      apiSettings: { action: "search event" },
    });

    this.get_configuration();

    // window.jQuery(this.$refs.standard_calendar).calendar({
    //   type: "date"
    // });

    // window.jQuery(this.$refs.module_dropdown).dropdown();
  },
};
</script>
